import { memo, useCallback, useState } from "react"
import FunctionsOutlinedIcon from '@mui/icons-material/FunctionsOutlined';
import DateRangeIcon from '@mui/icons-material/DateRange';
import LabelOutlinedIcon from '@mui/icons-material/LabelOutlined';
import hashFill from '@iconify/icons-eva/hash-fill';
import { Icon } from '@iconify/react';
import SvgIcon from "@mui/material/SvgIcon";
import { makeStyles } from '@mui/styles';
import PropTypes from 'prop-types'; 
import { Box, Grid, InputAdornment, List, ListItem, ListItemIcon, ListSubheader, TextField, Typography } from "@mui/material";

import { ReactComponent as InputSearchIcon } from "../../../assets/icons/icon-feather-search.svg";
import { ReactComponent as FilterSelectedIcon } from "../../../assets/icons/icon-field-selected.svg";

const useStyles = makeStyles((theme) => ({   
    fieldMenu: {
        boxShadow: '0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)',
    },
    autoCompleteInp: {
        fontWeight: 'normal'
    },
    fieldBtn: {
        position: 'absolute',
        right: '5px',
        bottom: '3px',
        cursor: 'pointer',
        minWidth: 'auto',
    },
    reportFieldList: {
        width: '100%',
        backgroundColor: '#fff',
        maxHeight: '350px',
        minHeight: '150px',
        overflow: 'auto',
        marginTop: '5px',
        borderRadius: '4px',
    },
    bgWhite: {
        backgroundColor: '#fff',
        borderRadius: '4px',
    },
    grey_bg: {
        backgroundColor: '#f1f1f1',
    }, 
    formInput: {
        paddingLeft: 0,
        '&::placeholder': {
            paddingLeft: '-10px',
        }
    },
    searchFieldListItem: {
        paddingTop: '0.6rem',
        paddingBottom: '0.6rem',
        '&:hover': {
            background: "#f1f1f1",
            zIndex: 9,
            "& $listItemDescription": {
                visibility: 'visible'
            },
            "& $searchFieldListMoreIcon": {
                visibility: 'visible'
            }
        },

    },
    listItemDescription: {
        display: 'none',
        '&:hover': {
            display: 'block'
        }
    },
    searchFieldListMoreIcon: {
        visibility: 'hidden',
        '&:hover': {
            visibility: 'visible'
        }
    }

}));

const CustomFieldList = ({list,searchKey,uniqueKey,displayKey,groupKey,selectedList,onSelectEvent}) => {
    const [searchField, setSearchField] = useState('')
    const classes = useStyles()

    const handleSearchField = useCallback((event) => {
        //console.log(event)
        setSearchField(event.target.value.toLowerCase())
    })

    const clickFieldListHandler = useCallback((event) => {
        //console.log(event)
        onSelectEvent(event)
    })

    return <Box className="re-edit-settings-fields-wrapper" >
        <TextField className=" re-edit-settings-fields-input" type="search"  placeholder="Search" autoComplete="off"
            onChange={handleSearchField}
            InputProps={{
                endAdornment: (
                <InputAdornment position="start">
                    <InputSearchIcon className="input_search_icon" sx={{ mr: '8px' }} />
                </InputAdornment>
                ),
                classes: {
                    input: classes.formInput,
                    adornedEnd: classes.bgWhite + " form_input"
                }
            }} 
        />
        <div className={`${classes.reportFieldList} re-edit-fieldlist`}>
            <ListSubheader className='re-edit-settings-fields-group-title' component="h2" id="nested-list-subheader">Measures</ListSubheader>
            <List component="nav">
                {
                    list.filter(obj => obj[searchKey].toLowerCase().includes(searchField) && obj[groupKey] === 'MEASURE').map((field,index) => (
                        <ListItem key={`custom-fields-${index}-${field[uniqueKey]}`} button 
                            className={`${selectedList.indexOf(field[uniqueKey]) > -1 ? 'visualize_list_text':''}  re-edit-settings-fields-item-title`} 
                            onClick={() => clickFieldListHandler(field)}
                            alignItems="flex-start">
                            <ListItemIcon  className='re-edit-settings-fields-item-icon'>
                                <FunctionsOutlinedIcon className="cm_dimension_icon" />
                            </ListItemIcon>

                            <Grid container className='report-visualise-field-listitem-content'>
                                <Grid item xs={12}>
                                    <Box display='flex' justifyContent='space-between' alignItems='center'>
                                        <Typography className="re-edit-settings-fields-item-name"> {field[displayKey]}</Typography>
                                        {
                                            (selectedList.indexOf(field[uniqueKey]) > -1)
                                                ?   <FilterSelectedIcon />
                                                :   null
                                        }
                                    </Box>
                                    
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography variant="subtitle2" className={classes.listItemDescription + " text-sub report-visualise-field-listitem-subtitle"}>{field.comment ? `${field?.description ?? ''} (${field.comment})`: `${field?.description ?? ''}`} </Typography>
                                </Grid>
                            </Grid>
                        </ListItem>
                    ))
                }
            </List>
            <ListSubheader className='re-edit-settings-fields-group-title' component="h2" id="nested-list-subheader">Dimensions </ListSubheader>
            <List component="nav">
                {
                //
                list.filter(obj => obj[searchKey].toLowerCase().includes(searchField) && obj[groupKey] === 'DIMENSION').map((field,index) => (
                    <ListItem key={`custom-fields-${index}-${field[uniqueKey]}`} button className={`${selectedList.indexOf(field[uniqueKey]) > -1 ? 'visualize_list_text':''}  re-edit-settings-fields-item-title`} onClick={() => clickFieldListHandler(field)} alignItems="flex-start">
                        <ListItemIcon  className='re-edit-settings-fields-item-icon'>
                            {field.type === "number" ? <Icon icon={hashFill} className="cm_measr_lbl num_icon" /> : field.type === "time" ? <DateRangeIcon className="cm_measr_lbl" /> : <LabelOutlinedIcon className="cm_measr_lbl" />}
                        </ListItemIcon>

                        <Grid container className='report-visualise-field-listitem-content'>
                            <Grid item xs={12}>
                                <Box display='flex' justifyContent='space-between' alignItems='center'>
                                    <Typography className="re-edit-settings-fields-item-name"> {field[displayKey]}</Typography>
                                    {
                                            (selectedList.indexOf(field[uniqueKey]) > -1)
                                                ?   <FilterSelectedIcon />
                                                :   null
                                    }
                                </Box>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography variant="subtitle2" className={classes.listItemDescription + " text-sub report-visualise-field-listitem-subtitle"}>{field.comment ? `${field?.description ?? ''} (${field.comment})`: `${field?.description ?? ''}`} </Typography>
                            </Grid>
                        </Grid>
                    </ListItem>
                ))}
            </List>
        </div>
    </Box>
}

CustomFieldList.propTypes = {
    list: PropTypes.isRequired,
    searchKey: PropTypes.isRequired,
    uniqueKey: PropTypes.isRequired,
    displayKey: PropTypes.isRequired,
    groupKey: PropTypes.isRequired,
    selectedList: PropTypes.isRequired,
    onSelectEvent: PropTypes.isRequired
  };

export default memo(CustomFieldList)